type ExerciseDetailContentProps = {
    title: string
    distanceUnit: string
    totalDistance: number
    htmlString: string
}

export const ExerciseDetailContent = ({
    title,
    distanceUnit,
    totalDistance,
    htmlString
}: ExerciseDetailContentProps) => {
    return (
        <div className="max-w-screen-fullHd mx-auto p-5 sm:p-14">
            <p className="font-medium text-2xl md:text-3xl mb-2">{title}</p>
            <p className="text-xl md:text-2xl uppercase font-light text-gray-600 mb-3">
                {totalDistance} {distanceUnit}
            </p>
            <section>
                <div
                    className="prose-lg max-w-4xl font-light"
                    dangerouslySetInnerHTML={{ __html: htmlString }}
                />
            </section>
        </div>
    )
}
